<template>
  <div>
    <div class="bsod container">
      <h1 class="neg title"><span class="bg">KIZI404 - BACKOFFICE</span></h1>

      <div v-if="!isGod">
        <label for="">Password: {{ pwdMsg }}</label
        ><input type="password" v-model="godPassword" />
        <button @click="checkIfGod">Switch on GodMode</button>
      </div>

      <div v-else>
        <a href="/main-hall" style="font-size: 2rem; text-align: center;"
          >Go back to the ship</a
        >
        <div>
          <h2>DOJO COURSE</h2>
          <p>
            <label for="">Course title</label>
            <input type="text" v-model="dojo_title" />
          </p>
          <p>
            <label for="">Author</label>
            <input type="text" v-model="dojo_author" />
          </p>
          <p>
            <label for="">Course content</label>
            <HTMLHelper></HTMLHelper>
          </p>
          <nav class="nav">
            <a class="link" @click="sendCourse()">{{ dojo_status }}</a>
          </nav>
        </div>
        <hr />
        <div>
          <h2>KIZI SPACENEWS</h2>
          <p>
            <label for="">News text</label>
            <textarea
              name=""
              id=""
              cols="30"
              rows="3"
              v-model="kizi_news"
            ></textarea>
          </p>
          <nav class="nav">
            <a class="link" @click="sendNews()">SEND</a>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";
import HTMLHelper from "@/components/utilities/HTMLHelper";
export default {
  name: "Backoffice",
  components: {
    HTMLHelper,
  },
  title: "Kizi Backoffice",
  data() {
    return {
      dojo_title: "",
      dojo_author: "",
      dojo_text: "",
      kizi_news: "",
      dojo_status: "SEND",
      news_status: "SEND",
      godPassword: "",
      pwdMsg: "",
      isGod: false,
    };
  },
  methods: {
    sendCourse() {
      if (this.dojo_title !== "" && this.dojo_author !== "" && this.dojo_text) {
        db.ref("dojo_course").push({
          title: this.dojo_title,
          text: this.dojo_text,
          author: this.dojo_author,
          created_at: new Date(),
        });
        this.dojo_title = "";
        this.dojo_text = "";
        this.dojo_author = "";
        this.dojo_status = "DOC SENT !";
        setTimeout(() => (this.dojo_status = "SEND"), 1500);
      }
    },
    sendNews() {
      if (this.kizi_news !== "") {
        db.ref("space_news").push({
          text: this.kizi_news,
          date: this.getKiziDate(),
          created_at: new Date(),
        });
        this.kizi_news = "";
        this.news_status = "DOC SENT !";
        setTimeout(() => (this.news_status = "SEND"), 1500);
      }
    },
    getKiziDate() {
      const date = new Date();
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      console.log(date, months, days);
      const kiziDate =
        months[date.getMonth()] +
        " " +
        days[date.getDay()] +
        " " +
        date.getDate() +
        " " +
        (date.getFullYear() + 18);

      return kiziDate;
    },
    checkIfGod() {
      if (this.godPassword == "514Waner313") {
        this.isGod = true;
        this.$cookies.set("is_god", true, 144 * 60 * 60);
      } else {
        this.pwdMsg = "Nope";
      }
    },
  },
  mounted() {
    if (this.$cookies.get("is_god") !== null) {
      this.isGod = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/landing-error.scss";

.nav {
  margin-top: 5px;
  margin-bottom: 50px;
}

input,
textarea {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  color: $light-grey;
  font-family: $font-stack;
  font-size: 1.5rem;
}

input {
  height: 2rem;
}
</style>
